import styled from 'styled-components';
import { colors, font, spacing, breakpoints } from '@chegg-ui/theme';
import { SecondaryButton, IconButton } from '@chegg-ui/button';
import { Input } from '@chegg-ui/input';
import { RadioGroup as CheggUIRadioGroup } from '@chegg-ui/radiogroup';
import { WarningCircleFillIcon } from '@chegg-ui/horizon-icons';
import { Dropdown } from '@chegg-ui/dropdown';
import { Checkbox } from '@chegg-ui/checkbox';
export var RecommendationBarIcon = styled(WarningCircleFillIcon).withConfig({
  componentId: "sc-15dutxw-0"
})(["color:", ";size:medium;"], colors.solar400);
export var SectionContainer = styled.div.withConfig({
  componentId: "sc-15dutxw-1"
})(["margin:", " 0px;"], spacing.px32);
export var RecommendationBarContainer = styled.div.withConfig({
  componentId: "sc-15dutxw-2"
})(["margin-bottom:20px;& + div{margin-top:0px;h3{margin-top:0px;}}"]);
export var SectionTitle = styled.h3.withConfig({
  componentId: "sc-15dutxw-3"
})(["font-size:", ";color:", ";"], font.size.px18, colors.dark);
export var StyledAddLinkButton = styled(SecondaryButton).withConfig({
  componentId: "sc-15dutxw-4"
})(["padding:0;"]);
export var AddLinkButtonLabel = styled.span.withConfig({
  componentId: "sc-15dutxw-5"
})(["font-weight:", ";font-size:", ";margin-left:", ";"], font.weight.normal, font.size.px14, spacing.px8);
export var SectionRow = styled.div.withConfig({
  componentId: "sc-15dutxw-6"
})(["flex:1;display:flex;flex-direction:row;flex-wrap:wrap;gap:", ";@media screen and (max-width:", "){flex-direction:column;}"], spacing.px12, breakpoints.md.max);
export var StyledInput = styled(Input).withConfig({
  componentId: "sc-15dutxw-7"
})(["margin-bottom:", ";flex:", ";input{", ";}"], spacing.px16, function (_ref) {
  var _ref$flexSize = _ref.flexSize,
    flexSize = _ref$flexSize === void 0 ? '1' : _ref$flexSize;
  return flexSize;
}, function (_ref2) {
  var _ref2$isRecommended = _ref2.isRecommended,
    isRecommended = _ref2$isRecommended === void 0 ? false : _ref2$isRecommended;
  return isRecommended && "background-color: ".concat(colors.yellow100);
});
export var StyledDropdown = styled(Dropdown).withConfig({
  componentId: "sc-15dutxw-8"
})(["margin-bottom:", ";"], spacing.px16);
export var StyledRadioGroup = styled(CheggUIRadioGroup).withConfig({
  componentId: "sc-15dutxw-9"
})(["", ";gap:", ";margin-bottom:", ";flex-wrap:wrap;gap:0px 20px;legend{font-size:", ";color:", ";font-weight:", ";font-size:", ";}"], function (_ref3) {
  var align = _ref3.align;
  return align === 'horizontal' && 'display: inline-flex;';
}, spacing.px24, spacing.px16, font.size.px14, colors.grey900, font.weight.bold, font.size.px14);
export var StyledPubDate = styled.div.withConfig({
  componentId: "sc-15dutxw-10"
})(["display:flex;flex-direction:row;margin-bottom:", ";@media screen and (max-width:", "),(max-width:", "){flex-direction:column;}@media screen and (max-width:", ") and (min-width:599px){flex-direction:row;}"], spacing.px16, breakpoints.lg.max, breakpoints.sm.max, breakpoints.md.max);
export var PubDateLabel = styled.div.withConfig({
  componentId: "sc-15dutxw-11"
})(["width:92px;flex-shrink:0;padding-top:", ";margin-right:", ";font-weight:", ";font-size:", ";align-self:center;@media screen and (max-width:", "),(max-width:", "){width:100%;padding-top:0px;margin-right:0px;margin-bottom:", ";}@media screen and (max-width:", ") and (min-width:599px){width:90px;padding-top:", ";margin-right:", ";margin-bottom:0;}"], spacing.px24, spacing.px24, font.weight.bold, font.size.px14, breakpoints.lg.max, breakpoints.sm.max, spacing.px8, breakpoints.md.max, spacing.px24, spacing.px24);
export var PubDateMainInputArea = styled.div.withConfig({
  componentId: "sc-15dutxw-12"
})(["width:100%;display:flex;gap:10px;& > .pubdate-input{margin-bottom:0;width:100%;flex:1;}"]);
export var DeleteButton = styled(IconButton).withConfig({
  componentId: "sc-15dutxw-13"
})(["margin-top:", ";padding:0;"], spacing.px12);
export var RecommendationBarBox = styled.div.withConfig({
  componentId: "sc-15dutxw-14"
})(["box-sizing:border-box;background-color:", ";padding:", ";display:flex;justify-content:center;"], colors.solar100, spacing.px4);
export var RecommendationBarContent = styled.div.withConfig({
  componentId: "sc-15dutxw-15"
})(["display:flex;align-items:center;gap:", ";"], spacing.px4);
export var RecommendationBarMessage = styled.div.withConfig({
  componentId: "sc-15dutxw-16"
})(["font-size:", ";line-height:", ";"], font.size.px14, font.lineHeight.md);
export var RecommendationBarIconWrapper = styled.div.withConfig({
  componentId: "sc-15dutxw-17"
})(["margin-left:", ";line-height:0;"], spacing.px12);
export var CheggUiCheckbox = styled(Checkbox).withConfig({
  componentId: "sc-15dutxw-18"
})(["margin-bottom:", ";"], spacing.px16);